import setEmojiResults from '../actions/setEmojiResults';
import setEmojiSelectedIndex from '../actions/setEmojiSelectedIndex';
import setQueryString from '../actions/setQueryString';
import EmojiPickerViewState from '../store/schema/EmojiPickerViewState';
import getPopularEmoji from 'owa-expressions-store/lib/utils/getPopularEmoji';
import matchEmoji from 'owa-expressions-store/lib/utils/matchEmoji';
import { action, orchestrator } from 'satcheljs';

const updateInlineSearch = action(
    'updateInlineSearch',
    (viewState: EmojiPickerViewState, queryString?: string) => ({
        viewState: viewState,
        queryString: queryString,
    })
);

orchestrator(updateInlineSearch, actionMessage => {
    const { viewState, queryString } = actionMessage;

    // Set the inline picker view state accordingly
    setQueryString(viewState, queryString || '');
    setEmojiSelectedIndex(viewState, 0);
    const emojiResults = queryString ? matchEmoji(queryString) : getPopularEmoji();
    setEmojiResults(viewState, emojiResults);
});

export default updateInlineSearch;
